import axios from 'axios'


const apiClient = axios.create({
  baseURL: process.env.VUE_APP_DOCUMENT_EDITOR_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})


const exportToPdf = (sfdt) => {
  return apiClient.post('/ExportToPdf', { content: sfdt }, { responseType: 'blob' })
}


export default {
  exportToPdf
}
